import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  [otherProps: string]: any;
}

function PropertyHint({ children, ...otherProps }: Props) {
  return (
    <div
      className="mt-1.5 text-xs text-gray-500 leading-relaxed"
      {...otherProps}
    >
      {children}
    </div>
  );
}

export default PropertyHint;
